import Http from '@/utils/http'
const baseUrl = '/app/teacher'

/**
 * 班级详情
 * @param id
 * 
*/

export const classInfo = id => Http.get(`${baseUrl}/class/${id}` )
